import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ShButtonComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { ResetSeasonForm, ResetStepper } from '../../../state/season-form/season-form.action';

@Component({
    selector: 'app-season-success',
    templateUrl: './season-success.component.html',
    imports: [ShButtonComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: { class: 'flex flex-1 flex-col' }
})
export class SeasonSuccessComponent {
    private router = inject(Router);
    private store = inject(Store);

    public onBackToHome(): void {
        this.router.navigate(['/']);
        this.store.dispatch(new ResetStepper());
        this.store.dispatch(new ResetSeasonForm());
    }

    public handleNavigateToSeasonsOverview(): void {
        this.router.navigate(['/seasons']);
    }
}
